/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/* ----------------------------------------------
Import and assign modules as global variables
---------------------------------------------- */

import * as Meteora from 'meteora';
import Classy from '@meteora-digital/classy';
import ModalController from '@meteora-digital/modal';
import TweenController from '@meteora-digital/tween';
import { tns } from "tiny-slider/src/tiny-slider";
import MagicScrolls from 'magic-scrolls';
window.Classy = Classy;
window.Meteora = Meteora;
window.TweenController = TweenController;
window.ModalController = ModalController;
window.tns = tns;
window.MagicScrolls = MagicScrolls;

/*------------------------------------------------------------------
Add conditional scripts to the ScriptLoader object below
------------------------------------------------------------------*/

function loadScripts() {
  // Add the src and a condition required to load the script
  window.ScriptsLoaded = ScriptLoader({
    './components/global': true,
    './elements/promotion-popup': document.querySelector('.js-promotion-popup'),
    './elements/subscription-popup': document.querySelector('.js-subscription-popup'),
    './elements/header': document.querySelector('.js-header'),
    './elements/buttons': document.querySelector('p .button'),
    './components/breakpoints': document.querySelector('[data-breakpoint]'),
    './components/limit-text': document.querySelector('[data-limit]'),
    './elements/banner': document.querySelector('.js-banner'),
    './components/parallax': document.querySelector('img-parallax'),
    './elements/search': document.querySelector('.js-search'),
    './elements/mobile-menu': document.querySelector('.js-mobile-menu'),
    './elements/videos': document.querySelector('[data-video]'),
    './elements/video-modals': document.querySelector('[data-video-modal]'),
    './elements/forms': document.querySelector('form.userform, .js-form form'),
    './elements/pardot-forms': document.querySelector('.js-pardot-form'),
    './elements/team-member': document.querySelector('.js-team-member, .js-people-holder'),
    './elements/sticky-elements': document.querySelector('.js-sticky'),
    './graphs/pie': document.querySelector('.js-pie'),
    './pages/pardot': document.querySelector('.js-pardot-page'),
    './pages/blog': document.querySelector('.js-blog-page'),
    './pages/people-holder': document.querySelector('.js-people-holder'),
    './pages/featured-services': document.querySelector('.js-featured-services, #PreferencesSelector_Select'),
    './tools/fund-tool-investment': document.querySelector('.js-fund-tool__investment-input'),
    './tools/fund-tool': document.querySelector('.js-fund-tool'),
    './components/character-limits': document.querySelector('[maxlength]')
  });
}

// Once the scripts have loaded
window.addEventListener('scripts-loaded', () => {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #f7ebde");
  document.body.classList.add('scripts-loaded');
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadScripts);
} else {
  loadScripts();
}